import { useQuery } from '@tanstack/react-query';
import fetchNotesOfCourse from '../../api/Notes';

const useFetchNotesOfCourse = (courseId, { page = 1, pageSize = 10, text = '' } = {}) => {
  return useQuery({
    queryKey: ['fetchNotesOfCourse', courseId, page, pageSize, text],
    queryFn: () => fetchNotesOfCourse(courseId, { page, pageSize, text }),
  })
}

export default useFetchNotesOfCourse;